/**
 * @param {number} length
 * @return {Array}
 */
export default length => Array.apply(null, { length })



// WEBPACK FOOTER //
// ./src/components-base/utils/range.js